import React, { useCallback, useState } from 'react'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { altTextSourceDataAtom } from './atoms'
import { Box, Button, TextField } from '@mui/material'
import { GoogleLoginButton } from 'infrastructure/googleDrive'
import { GoogleSheetImport } from '../googleApis/GoogleSheetImport'
import { parseCsvDataWithHeaderRow } from '../../Helpers'

export const AddButtonTitle = 'Add Alt Text'

export function SourceAddition() {
  const [adding, setAdding] = useState(false)
  const [newUrl, setNewUrl] = useState('')
  const [newAltText, setNewAltText] = useState('')
  const sourceSetter = useSetAtom(altTextSourceDataAtom)

  if (!adding) {
    return (
      <Box>
        <Button onClick={() => setAdding(true)}>{AddButtonTitle}</Button>
      </Box>
    )
  }

  const doAdd = () => {
    if (!newUrl || !newAltText) return
    sourceSetter((prev) => {
      return {
        ...prev,
        [newUrl]: {
          url: newUrl,
          altText: newAltText,
        },
      }
    })
    setNewUrl('')
    setNewAltText('')
  }

  return (
    <Box padding="20px" borderRadius="5px" style={{ border: 'solid 1px' }}>
      <Box>Add Alt Text</Box>
      <TextField
        value={newUrl}
        label="URL"
        onChange={({ target: { value } }) => setNewUrl(value)}
      />
      <TextField
        value={newAltText}
        label="Alt Text"
        onChange={({ target: { value } }) => setNewAltText(value)}
      />
      <Button disabled={!newUrl || !newAltText} onClick={doAdd}>
        Add
      </Button>
      <Button onClick={() => setAdding(false)}>Cancel</Button>
      <Box>
        <GoogleLoginButton
          hideWhenLoggedIn={true}
          LoggedInComponent={FromGoogleSheet}
        />
      </Box>
    </Box>
  )
}

function FromGoogleSheet() {
  const getSheet = useGoogleSheetAdd()

  return <GoogleSheetImport onRetrieveData={getSheet} />
}

function useGoogleSheetAdd() {
  const setter = useSetAtom(altTextSourceDataAtom)
  return useCallback(
    (csvData: string[][]) => {
      const { data } = parseCsvDataWithHeaderRow<{
        altText: string
        imageUrl: string
      }>(csvData)
      setter((prev) => {
        return data.reduce((acc, { imageUrl, altText }) => {
          return {
            ...acc,
            [imageUrl]: {
              altText,
              url: imageUrl,
            },
          }
        }, prev)
      })
    },
    [setter],
  )
}
